import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc220352"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-tool" }
const _hoisted_2 = ["src"]

import {EyeOutlined, EditOutlined, CloseOutlined} from "@ant-design/icons-vue";
import ImagePreview from "@/app/editor/views/ImagePreview.vue";
import {reactive} from "vue";
import PopupBase from "@/components/PopupBase.vue";
import {IImageTemplateDrawOption, IThemeImagePreview} from "@/app/editor/types";
import {BasicModuleV1} from "@/app/editor/modules/basic/v1";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeImageTemplatePreView',
  props: {
    image: {},
    title: {},
    subTitle: {},
    options: {},
    basic: {}
  },
  emits: ['onChange', 'onEdit'],
  setup(__props: any) {




const info = reactive({preview: {show: false}, setting: {show: false}})


return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_flex, { gap: "middle" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.image)
            ? (_openBlock(), _createBlock(ImagePreview, {
                key: 0,
                image: _ctx.image,
                height: "100px",
                width: "auto"
              }, null, 8, ["image"]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_flex, {
            gap: "small",
            align: "center",
            justify: "center",
            class: "mask"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(EyeOutlined), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (info.preview.show=true))
              }),
              (_ctx.options.length)
                ? (_openBlock(), _createBlock(_unref(EditOutlined), {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (info.setting.show=true))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_flex, {
          vertical: "vertical",
          justify: "center",
          gap: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_typography_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_typography_text, { type: "secondary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.subTitle), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onChange')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("更换样式")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(PopupBase, {
      open: info.preview.show,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((info.preview.show) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(CloseOutlined), {
          style: {"position":"absolute","top":"14px","right":"14px","color":"white"},
          onClick: _cache[3] || (_cache[3] = ($event: any) => (info.preview.show=false))
        }),
        _createElementVNode("img", {
          src: _ctx.image?.src,
          alt: "",
          style: {"max-height":"80vh"}
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: info.setting.show,
      "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => ((info.setting.show) = $event)),
      title: "设置图片"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (info.setting.show = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("完成")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "tpl",
          model: info.setting
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (o, i) => {
              return (_openBlock(), _createBlock(_component_a_form_item, {
                key: i,
                label: o.title
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: o.text,
                    onChange: ($event: any) => (_ctx.basic.onOptionChange($event,o.image_template_id,i)),
                    maxlength: o.length_max<o.length_min?o.length_min:o.length_max,
                    "allow-clear": "",
                    "show-count": "",
                    status: o.text.length<o.length_min ? 'error' : ''
                  }, null, 8, ["value", "onChange", "maxlength", "status"])
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})